import { Component } from 'vue-property-decorator';
import BaseMixin from "@pazion/pazion-core/src/mixins/base.mixin";
import { mapState } from "vuex";
import { IPermissionConfig } from '../models/permission-model';
import {authentication} from "@pazion/pazion-core/src/store";


@Component({
  computed: {
    ...mapState({ rolePermissionsState: (state) => state.permission.rolePermissions })
  }
})
export default class PermissionService extends BaseMixin {

    /**
     * NOTE:
     * apiPackage
     * base
     * config
     * featureFlags
     * profileFlags
     */
    rolePermissions = {} as IPermissionConfig;
    rolePermissionsState!: IPermissionConfig;


    //Recursive flags checking
    userHasFlag(flagToCheck: string): boolean {

        if (flagToCheck in this.userPermissionProfileFlags) {
            return this.userPermissionProfileFlags[flagToCheck];
        }
        let lastdot = flagToCheck.lastIndexOf('.');
        while (lastdot >= 0) {

            const previousKey = flagToCheck.substring(0, lastdot);
            const wildCardKey = previousKey + '.*';
            if (this.userPermissionProfileFlags[wildCardKey] !== undefined) {
                return this.userPermissionProfileFlags[wildCardKey];
            }
            lastdot = previousKey.lastIndexOf('.');
        }
        return false;
    }

    hasFeatureFlag(featureFlagToCheck: string): boolean {
        if (authentication.getProfile) {
            if (authentication.getProfile.config != undefined) {
                return authentication.getProfile.config.featureFlags[featureFlagToCheck] ?? false;
            }
        }
        return false;
    }

    get userPermissionProfileFlags() {
        if (this.rolePermissionsState &&
            this.rolePermissionsState.hasOwnProperty('profileFlags')) {
            return this.rolePermissionsState.profileFlags
        }
        if (localStorage.getItem('vuex')) {
            const vuex = localStorage.getItem('vuex');
            const settings = vuex && JSON.parse(vuex)
            return settings && settings?.authentication && settings?.authentication?.settings.profileFlags
        }
    }

    hasProfileFlag(flagToCheck: string): boolean {
        if (this.userPermissionProfileFlags) {
            return this.userHasFlag(flagToCheck);
        }
        return false;
    }
}